module.exports = __webpack_public_path__ + "img/takahashi-name-logo.f91be54f.svg";